import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService, PlanStepEnum } from '../../core';


/**
 * Pipe to convert Plan Step enum to display value.
 */
@Pipe({
	name: 'planStepLabel'
})
export class PlanStepLabelPipe implements PipeTransform {

	constructor(private readonly langSrv: LanguageService) { }

	transform(planStep?: PlanStepEnum | null): string {
		if (!planStep) return '';
		return planStepTranslate(planStep, this.langSrv.labels());
	}

}


export const planStepTranslate = (planStep: PlanStepEnum, labels: any): string => {
	switch (planStep) {
		case PlanStepEnum.None: return '';
		case PlanStepEnum.Deformity: return labels.PLAN_STEP_DEFORMITY_LABEL;
		case PlanStepEnum.EOC: return labels.PLAN_STEP_EOC_LABEL;
		case PlanStepEnum.Templating: return labels.PLAN_STEP_TEMPLATING_LABEL;
		case PlanStepEnum.RPM: return labels.PLAN_STEP_RPM_LABEL;
		case PlanStepEnum.Mounting: return labels.PLAN_STEP_MOUNTING_LABEL;
		case PlanStepEnum.Schedule: return labels.PLAN_STEP_SCHEDULE_LABEL;
		case PlanStepEnum.Report: return labels.PLAN_STEP_REPORT_LABEL;
		case PlanStepEnum.Adjust: return labels.PLAN_STEP_REPORT_LABEL;
		default: return planStep;
	}
}
